import { render, staticRenderFns } from "./PersonnelEvaluationFiles.vue?vue&type=template&id=3b4748a0"
import script from "./PersonnelEvaluationFiles.vue?vue&type=script&lang=js"
export * from "./PersonnelEvaluationFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports